import api from "./api-config";
import { CaseDocumentDTO } from "../models/CaseDocument";

export const caseDocumentService = {
  getAllCaseDocuments: async (
    params: {
      page?: number;
      size?: number;
      sort?: string[];
      "id.greaterThan"?: number;
      "id.lessThan"?: number;
      "id.equals"?: number;
      "name.contains"?: string;
      "name.equals"?: string;
      "documentType.contains"?: string;
      "documentType.equals"?: string;
      "uploadDate.greaterThan"?: string;
      "uploadDate.lessThan"?: string;
      "uploadDate.equals"?: string;
      "filepath.contains"?: string;
      "filepath.equals"?: string;
      "extension.contains"?: string;
      "extension.equals"?: string;
      "casesId.equals"?: number;
      distinct?: boolean;
    } = {}
  ) => {
    const response = await api.get<CaseDocumentDTO[]>("/case-documents", {
      params: {
        ...params,
        sort: params.sort?.join(","),
      },
    });
    return response.data;
  },

  getCaseDocument: async (id: number) => {
    const response = await api.get<CaseDocumentDTO>(`/case-documents/${id}`);
    return response.data;
  },

  createCaseDocument: async (caseDocumentData: CaseDocumentDTO) => {
    const response = await api.post<CaseDocumentDTO>(
      "/case-documents",
      caseDocumentData
    );
    return response.data;
  },

  updateCaseDocument: async (id: number, caseDocumentData: CaseDocumentDTO) => {
    const response = await api.put<CaseDocumentDTO>(
      `/case-documents/${id}`,
      caseDocumentData
    );
    return response.data;
  },

  deleteCaseDocument: async (id: number) => {
    const response = await api.delete(`/case-documents/${id}`);
    return response.data;
  },

  partialUpdateCaseDocument: async (
    id: number,
    caseDocumentData: Partial<CaseDocumentDTO>
  ) => {
    const response = await api.patch<CaseDocumentDTO>(
      `/case-documents/${id}`,
      caseDocumentData
    );
    return response.data;
  },

  countCaseDocuments: async (
    params: {
      "id.greaterThan"?: number;
      "id.lessThan"?: number;
      "id.equals"?: number;
      "name.contains"?: string;
      "name.equals"?: string;
      "documentType.contains"?: string;
      "documentType.equals"?: string;
      "uploadDate.greaterThan"?: string;
      "uploadDate.lessThan"?: string;
      "uploadDate.equals"?: string;
      "filepath.contains"?: string;
      "filepath.equals"?: string;
      "extension.contains"?: string;
      "extension.equals"?: string;
      "casesId.equals"?: number;
      distinct?: boolean;
    } = {}
  ) => {
    const response = await api.get<number>("/case-documents/count", { params });
    return response.data;
  },

  uploadCaseDocument: async (
    name: string,
    documentType: string,
    caseId: number,
    file: File
  ) => {
    const formData = new FormData();
    formData.append("file", file);
    const response = await api.post<string>(
      "/case-documents/upload",
      formData,
      {
        params: { name, caseId, documentType },
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return response.data;
  },

  downloadCaseDocument: async (id: number) => {
    const response = await api.get<Blob>(`/case-documents/download/${id}`, {
      responseType: "blob",
    });
    return response.data;
  },
};
